import FormCocktail from './FormCocktail';
export default FormCocktail;
